/* eslint-disable @typescript-eslint/no-non-null-assertion */
import type { SalesUnit, TSelectOption } from "@hsr/types";

export const buildSalesUnitsOptions = (
  units: SalesUnit[]
): { options: TSelectOption[]; selectedOption: string } | undefined => {
  if (!units) return undefined;

  const activeUnits = units.filter((unit) => unit.active !== false);
  if (!activeUnits.length) return undefined;

  const newUnits: TSelectOption[] | undefined = activeUnits.map((unit) => ({
    label: unit.name!,
    //value: unit.amount!.toString(),
    value: unit.name!,
    selected: unit?.isDefault ? true : false
  }));
  if (!newUnits) return undefined;

  const isPreSelected = newUnits?.some((unit) => unit.selected === true);
  if (!isPreSelected && newUnits.length) newUnits[0].selected = true;

  const selectedOption =
    newUnits?.find((unit) => unit.selected === true)?.value || "";

  return { options: newUnits, selectedOption };
};
